import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Panel from 'components/v2/Panel';
import ListItem from 'components/v2/list/ListItem';
export default function List({ title, heading, className, children, testDataId, }) {
    function renderHeading() {
        if (title) {
            return (React.createElement("h3", { className: "mb-4", "data-testid": `${testDataId || 'title'}` }, title));
        }
        if (heading) {
            return (React.createElement("div", { className: "mb-4", "data-testid": `${testDataId || 'heading'}` }, heading()));
        }
        return null;
    }
    return (React.createElement(React.Fragment, null,
        renderHeading(),
        React.createElement(Panel, { className: classNames('divide-y divide-gray-200', className) }, children)));
}
List.propTypes = {
    title: PropTypes.string,
    heading: PropTypes.func,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.arrayOf([PropTypes.string, PropTypes.object]),
    ]),
};
List.Item = ListItem;
